import './App.css';

function App() {
  return (
    <div className="App h-screen flex items-center justify-center">
      <div className="text-gray-100 text-center">
        <p className="text-6xl mb-3">Megma</p>
        <p className="">Domótica para los amigos</p>
      </div>
    </div>
  );
}

export default App;
